import { useEffect } from 'react';
import triggerGoogleTagManagerCustomEvent from '../../common/utils/triggerGoogleTagManagerCustomEvent';
import GtmEvents from '../constants/gtmEvents';

function useGtmTextFieldTracking() {
  useEffect(() => {
    const handleBlur = (e: FocusEvent) => {
      if (!(e.target instanceof HTMLInputElement)) {
        return;
      }
      if (!['text', 'email', 'tel', 'url', 'search', 'password'].includes(e.target.type)) {
        return;
      }

      triggerGoogleTagManagerCustomEvent(GtmEvents.TEXTFIELD_INPUT, {
        length: e.target.value.length,
      });
    };

    document.addEventListener('focusout', handleBlur, { capture: true });
    return () => {
      document.removeEventListener('focusout', handleBlur, { capture: true });
    };
  }, []);
}

export default useGtmTextFieldTracking;
